import { render } from "./SelectProvider.vue?vue&type=template&id=8be4528c"
import script from "./SelectProvider.vue?vue&type=script&lang=js"
export * from "./SelectProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__